export default __webpack_public_path__ + "static/media/Location.7582052f.svg";